import React from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import PopUp from '../../pages/popup/PopUp';


const Footer = () => {
  return (
    <>
      
        <footer>
          <div className="footer-area-top">
            <div className="container">
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="footer-box">
                    <h2 className="title-bold-light title-bar-left text-uppercase">त्वरित समाचार</h2>
                    <ul className="most-view-post">
                      <li>
                        <div className="media">
                          <a to="post-style-1.html">
                            <img src="/assets/img/Ladli-stkiyBehna.png" style={{}} alt="post" className="img-fluid" />
                          </a>
                          <div className="media-body">
                            <h3 className="title-medium-light size-md mb-10">
                              <a to="#">लाड़ली बहना योजना मध्यप्रदेश सरकार की एक प्रमुख महिला कल्याण योजना है, जिसे मार्च 2023 में शुरू किया गया था।</a>
                            </h3>
                            <div className="post-date-light">
                              <ul>
                                <li>
                                  <span>
                                    <i className="fa fa-calendar" style={{ color: "black" }} aria-hidden="true" />
                                  </span>मार्च 2023
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </li>

                    </ul>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-3 col-md-6 col-sm-12">
                  <div className="footer-box">
                    <h2 className="title-bold-light title-bar-left text-uppercase">त्वरित लिंक</h2>
                    <ul className="popular-categories">
                      <li>
                        <Link to="/">होम
                        </Link>
                      </li>
                      <li>
                        <Link to="/country">देश
                        </Link>
                      </li>
                      <li>
                        <Link to="/breaking-news">ताजा ख़बरें
                        </Link>
                      </li>
                      <li>
                        <Link to="/politics">राजनीति
                        </Link>
                      </li>
                      <li>
                        <Link to="/about-us">हमारे बारे में
                        </Link>
                      </li>

                    </ul>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-5 col-md-12 col-sm-12">
                  <div className="footer-box">
                    <h2 className="title-bold-light title-bar-left text-uppercase">हमारे बारे में</h2>
                    <p style={{ color: "white" }}>स्टार न्यूज़ नेटवर्क में, हम विविध विषयों पर विश्वसनीय, निष्पक्ष और समय पर समाचार प्रदान करने के लिए प्रतिबद्ध हैं। ब्रेकिंग हेडलाइन से लेकर गहन विश्लेषण तक, हम सुनिश्चित करते हैं कि हमारे दर्शक सूचित, जुड़े और सशक्त रहें।</p>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-area-bottom">
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <a to="index.html" className="footer-logo img-fluid">
                    <img style={{ height: "", width: "200px", marginTop: "-50px", borderRadius: "5px" }} src="https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688158/star_logo_nlerzd.jpg" alt="logo" className="img-fluid" />
                  </a>
                  <ul className="footer-social" style={{ marginTop: "-25px" }}>
                    <li>
                      <a href="https://www.facebook.com/p/Star-News-Networks-61571596704367/" target="_blank" title="facebook">
                        <i className="fa fa-facebook" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://wa.me/917987667358" title="twitter" target="_blank">
                        <i className="fa fa-whatsapp" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <Link to="https://www.youtube.com/@Starnewsnetworks88" target="_blank" title="google-plus">
                        <i className="fa fa-youtube" aria-hidden="true" />
                      </Link>
                    </li>

                  </ul>
                  <p style={{ color: "white" }}>2026 © Star News Network | <a href="tel:+91  8982471422" style={{ color: "white" }} > Designed by Web solution & digital marketing </a></p>
                </div>
              </div>
            </div>
          </div>
        </footer>


      <WhatsappIcon />



    </>
  )
}

export default Footer